












import { Component, Prop, Vue } from "vue-property-decorator"

// To be remove
@Component
export default class ConfirmationModal extends Vue {
  @Prop({ default: false }) public readonly isModalVisible!: boolean

  public isVisible = this.isModalVisible
  public isFormOpen = false

  public get irrigationArea(): string {
    return this.$store.getters.lastIrrigationTarget?.area.toFixed(2) || ""
  }

  constructor() {
    super()
  }

  public closeModal(): void {
    this.isVisible = false
  }

  public openForm(): void {
    this.isFormOpen = true
    this.isVisible = false
  }
}
